import 'trix';
import '@rails/actiontext';

console.log('application.js');

const { id } = document.body;





console.log('Body ID:', id);

if (id === 'home-authenticated_index') {
  console.log('Loading authenticated home Vue app');
  import('../javascript/apps/authenticated/main.js');
} else if (id === 'home-unauthenticated_index') {
  console.log('Loading unauthenticated home Vue app');
  import('../javascript/apps/unauthenticated/main.js');
} else if (id === 'devise-sessions-new') {
  import('../javascript/views/devise/sessions/new.js');
}

// Setup header
const profileMenuLink = document.getElementById('profile-menu-link');
const profileDropdown = document.getElementById('profile-dropdown');

if (profileMenuLink && profileDropdown) {
  profileMenuLink.addEventListener('click', () => {
    // e.preventDefault();
    profileDropdown.classList.toggle('show');
  });
}
